import { useDisplay } from 'vuetify';

export default () => {
  const { mdAndUp } = useDisplay();
  const navMenuShown = computed(() => {
    return mdAndUp.value;
  });
  const mobileMode = computed(() => !navMenuShown.value);
  const desktopMode = computed(() => navMenuShown.value);

  return {
    mobileMode,
    desktopMode,
    navDrawerMode: mobileMode,
    sidebarMode: desktopMode,
  };
};
